import React from "react";
import { useIntl } from "react-intl";

interface FormatNameOptions {
	title?: string;
	firstName: string;
	lastName: string;
}

export function useFormatName(): (options: FormatNameOptions) => string {
	const { locale } = useIntl();
	return React.useCallback(
		({ title = "", firstName, lastName }) => {
			let name = "";
			if (title !== "") {
				name += `${title} `;
			}
			if (locale === "hu") {
				name += `${lastName} ${firstName}`;
			} else {
				name += `${firstName} ${lastName}`;
			}
			return name;
		},
		[locale]
	);
}

interface FormatInitialsOptions {
	firstName: string;
	lastName: string;
}

export function useFormatInitials(): (
	options: FormatInitialsOptions
) => string {
	const { locale } = useIntl();
	return React.useCallback(
		({ firstName, lastName }) => {
			const firstInitial = getFirstLetter(toTitleCase(firstName));
			const lastInitial = getFirstLetter(toTitleCase(lastName));
			let initials = "";
			if (locale === "hu") {
				initials += `${lastInitial}${firstInitial}`;
			} else {
				initials += `${firstInitial}${lastInitial}`;
			}
			return initials;
		},
		[locale]
	);
}

function toTitleCase(s: string): string {
	return s[0].toUpperCase() + s.slice(1).toLowerCase();
}

const complexLetters = ["Cs", "Dz", "Dzs", "Gy", "Ly", "Ny", "Sz", "Ty", "Zs"];

function getFirstLetter(s: string): string {
	for (const l of complexLetters) {
		if (s.startsWith(l)) {
			return l;
		}
	}
	return s[0];
}
